import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";
import { FnrToggleChild } from "UI/FnrToggle2";

export default function SignupTypeBox({ ID, label, icon, onClick }) {
  return (
    <Wrapper onClick={() => onClick(ID)}>
      <FnrToggleChild>
        <Inside>
          <Icon>
            <FnrIcon fad icon={icon} />
          </Icon>
          <Title>{label}</Title>
        </Inside>
      </FnrToggleChild>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  width: 50%;
`;
const Inside = styled.div`
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  transition: color 0.2s;
  &:hover {
    color: #278dc1;
  }
`;
const Icon = styled.div`
  font-size: 24px;
  line-height: 24px;
  width: 32px;
  text-align: center;
  margin-right: 12px;
  flex-shrink: 0;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 400;
  min-height: 43px;
  display: flex;
  align-items: center;
`;
